import React, { useState, useEffect } from 'react';
import { Table, Tag, Space, Input, DatePicker } from 'antd';
import { SearchOutlined, AuditOutlined } from '@ant-design/icons';
import { getInternalReportingAuditLogs } from '../../services/internalReportingService';

const { RangePicker } = DatePicker;

const AuditTrailTab = () => {
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState('');

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await getInternalReportingAuditLogs();
      if (res?.status) {
        setLogs(res.data);
      }
    } catch (err) {
      console.error('Failed to fetch audit logs:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const columns = [
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text) => (
        <Space>
          <AuditOutlined style={{ color: '#1890ff' }} />
          <strong>{text}</strong>
        </Space>
      ),
    },
    {
      title: 'Report / Target',
      dataIndex: 'reportName',
      key: 'reportName',
    },
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: 'Timestamp',
      dataIndex: 'timestamp',
      key: 'timestamp',
    },
    {
      title: 'Details',
      key: 'details',
      render: (_, record) => (
        record.format ? <Tag color="blue">{record.format} Export</Tag> : '-'
      ),
    },
  ];

  const filteredLogs = logs.filter(
    (log) =>
      log.action.toLowerCase().includes(search.toLowerCase()) ||
      log.reportName.toLowerCase().includes(search.toLowerCase()) ||
      log.user.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="audit-trail-tab">
      <div className="reg-filter-header" style={{ marginBottom: '16px' }}>
        <Space wrap size="middle">
          <Input
            placeholder="Search activity..."
            prefix={<SearchOutlined />}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 300 }}
          />
          <RangePicker />
        </Space>
      </div>

      <Table
        loading={loading}
        columns={columns}
        dataSource={filteredLogs}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        className="reg-table"
      />
    </div>
  );
};

export default AuditTrailTab;
